import { CLIENT } from '../constants';
import { FetchAPI } from '../Main/fetchAPI';
import { GetRemainingHoursProperties } from './userSessionAllocationProperties';

export const UserSessionAllocation = {
	getUserRemainingHours: ({ userId, sessionType, date }: GetRemainingHoursProperties) => {
		const query = new URLSearchParams();
		query.set('date', date);
		query.set('sessionType', `${sessionType}`);

		return FetchAPI.getJson({
			urlStr: `${CLIENT}/user-session-allocations/user/${userId}/remaining-hours-details?${query.toString()}`,
		});
	},
};
